export default __webpack_public_path__ + "static/media/iconSort.fc09e746.svg";